<script setup>
import { defineComponent, ref, onMounted } from 'vue'
import axios from 'axios'
import { loadPayline } from '@/payline-helper.js'

defineComponent({
  name: 'FabricationCarte',
})
const prenom = ref(null)
const nom = ref(null)
const adresse = ref(null)
const codePostal = ref(null)
const ville = ref(null)
const complementAdresse = ref(null)
const pays = ref('France')
const dateNaissance = ref(null)
const email = ref(null)
const mobile = ref()
const imageFile = ref(null)
const justificatifDetenteurFile = ref(null)
const justificatifSignataireFile = ref(null)
const imageValidationMessage = ref('')
const justificatifValidationMessage = ref('')
const visibiliteJustificatif = ref(false)
const isFuturDetenteur = ref(false)
const dateDebutValidite = ref(null)
let justificatifFile = []
const justificatifMessage = ref('')
const dateDebutValiditeMin = ref(null)
const produit = ref(null)
const catalogue = ref([])
catalogue.value.sort((one, two) => (one.libelle > two.libelle ? 1 : -1))

const montantFabricationCarte = ref(5.0)

const erreurMessage = ref(null)

const paysList = ref([
  'France',
  'Allemagne',
  'Andorre',
  'Belgique',
  'Espagne',
  'Italie',
  'Luxembourg',
  'Monaco',
  'Suisse',
])

const loading = ref(false)
const paymentToken = ref(undefined)
const isRenseignementsChecked = ref(null)
const isRGPDChecked = ref(null)
const needFacture = ref(false)
const modeRetrait = ref('Retrait sur place')
const isAchatCollapsed = ref(false)
const isPaiementCollapsed = ref(true)
const MAX_FILE_SIZE = 2 * 1024 * 1024 // 25 Mo

onMounted(() => {
  dateDebutValiditeMin.value = ajoutDes7JoursADateDeDebutTitre()
})

function ajoutDes7JoursADateDeDebutTitre() {
  const today = new Date()
  today.setDate(today.getDate() + 7)
  return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
}

//function de gestion
function validationFormulaire(e) {
  e.preventDefault()
  creationVente()
}

function toggleCollapse() {
  isAchatCollapsed.value = !isAchatCollapsed.value
  isPaiementCollapsed.value = !isPaiementCollapsed.value
}

function onChangeImageFile(event) {
  const file = event.target.files[0]
  if (file && file.type !== 'image/jpeg' && file.type !== 'image/png') {
    imageValidationMessage.value =
      'Format incorrect. Veuillez télécharger une image JPG ou PNG.'
    event.target.value = null
  } else {
    imageValidationMessage.value = ''
    imageFile.value = file
  }
}

function onChangeJustificatifDetenteurFile(event) {
  const file = event.target.files[0]
  if (file && file.type !== 'application/pdf') {
    justificatifValidationMessage.value =
      'Format incorrect. Veuillez télécharger un PDF'
    event.target.value = null
  } else {
    justificatifValidationMessage.value = ''
    justificatifDetenteurFile.value = file
  }
}
function onChangeJustificatifSignataireFile(event) {
  const file = event.target.files[0]
  if (file && file.type !== 'application/pdf') {
    justificatifValidationMessage.value =
      'Format incorrect. Veuillez télécharger un PDF'
    event.target.value = null
  } else {
    justificatifValidationMessage.value = ''
    justificatifSignataireFile.value = file
  }
}

function toCurrency(value) {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  })
  return formatter.format(value)
}

function creationVente() {
  if (loading.value) {
    return
  } else {
    loading.value = true
  }

  const formData = new FormData()
  formData.append('prenom', prenom.value)
  formData.append('nom', nom.value)
  formData.append('adresse', adresse.value)
  formData.append('codePostal', codePostal.value)
  formData.append('ville', ville.value)
  formData.append('complementAdresse', complementAdresse.value)
  formData.append('pays', pays.value)
  formData.append('email', email.value)
  formData.append('mobile', mobile.value)
  formData.append('imageFile', imageFile.value)
  formData.append('identiteFile', justificatifDetenteurFile.value)
  formData.append('justificatifFile', justificatifSignataireFile.value)
  if (Array.isArray(justificatifFile)) {
    justificatifFile.forEach(file => {
      formData.append('justificatifFile', file)
    })
  } else {
    formData.append('justificatifFile', justificatifFile)
  }
  formData.append('isRenseignementsChecked', isRenseignementsChecked.value)
  formData.append('isRGPDChecked', isRGPDChecked.value)
  formData.append('needFacture', needFacture.value)
  formData.append('codeProduit', produit.value.codeProduit)
  formData.append('dateDebutValidite', dateDebutValidite.value)
  formData.append('reductionId', produit.value.reductionId)
  formData.append('support', 'NFC')
  formData.append('dateNaissance', dateNaissance.value)
  formData.append('modeRetrait', modeRetrait.value)

  console.log('Creation vente')
  axios
    .post('commandes/prepareFabricationCarte', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(
      succes => {
        console.log(succes)
        paymentToken.value = succes.data.token
        console.log('Token', paymentToken.value)
        console.log(produit.value)
        montantFabricationCarte.value = produit.value.tarif
        // On récupère le token et on initialise payline
        loadPayline(succes.data.production)
          .then(() => {
            toggleCollapse()
          })
          .catch(error => {
            console.error("Erreur lors de l'initialisation de Payline", error)
            erreurMessage.value = "Erreur lors de l'initialisation de Payline."
          })
      },
      reason => {
        console.error('ERREUR', reason.response)
        if (reason.response) {
          switch (reason.response.status) {
            case 400:
              erreurMessage.value = 'Erreur : ' + reason.response.data
              break
            default:
              erreurMessage.value = "Une erreur inattendue s'est produite."
          }
        } else {
          erreurMessage.value = 'Erreur réseau ou serveur non joignable.'
        }
      },
    )
    .catch(erreur => {
      console.error('Erreur lors de la création de la vente', erreur)
      erreurMessage.value =
        'Erreur lors de la création de la vente. Veuillez réessayer plus tard.'
      document.getElementById('modal_erreur').showModal()
    })
}

function recommencerAchat() {
  window.location.reload()
}

function validerDate(date) {
  if (!date) {
    return true
  }
  return date.match(/^(\d{4})-\d{2}-\d{2}$/)
}

function fetchCatalogue() {
  erreurMessage.value = ''
  if (!validerDate(dateNaissance.value)) {
    erreurMessage.value = 'Erreur: mauvais format de date'
    dateNaissance.value = null
    return
  }
  if (!validerDate(dateDebutValidite.value)) {
    erreurMessage.value = 'Erreur: mauvais format de date'
    dateDebutValidite.value = null
    return
  }
  produit.value = null
  catalogue.value = []
  if (
    dateNaissance.value !== null &&
    dateDebutValidite.value !== null &&
    isDateValid(dateNaissance.value) &&
    isDateValid(dateDebutValidite.value)
  ) {
    axios
      .get(
        'produits/produit-vente/' +
          dateNaissance.value +
          '/' +
          dateDebutValidite.value,
      )
      .then(
        succes => {
          catalogue.value = succes.data
        },
        erreur => {
          if (erreur.response && erreur.response.status === 400) {
            erreurMessage.value = 'Le format des dates est invalide.'
          } else {
            erreurMessage.value = 'Erreur lors de la récupération du catalogue.'
          }
          catalogue.value = null
          console.log(erreur)
        },
      )
  }
}

function isDateValid(dateStr) {
  return !isNaN(new Date(dateStr))
}

function onChangeJustificatifFile(event) {
  console.log(event.target.files)
  let files = Array.from(event.target.files)
  if (files.some(file => file.size > MAX_FILE_SIZE)) {
    justificatifMessage.value =
      'Un ou plusieurs fichiers dépassent ' +
      MAX_FILE_SIZE / 1024 / 1024 +
      ' Mo.'
    event.target.value = null
    return
  }
  justificatifMessage.value = ''
  justificatifFile = files
}

function verificationJustificatif(item) {
  produit.value = item
  if (produit.value.reductionId) {
    visibiliteJustificatif.value = true
  } else {
    visibiliteJustificatif.value = false
  }
  console.log(visibiliteJustificatif.value)
}
</script>

<template>
  <div
    :class="{ collapse: !isPaiementCollapsed, show: isPaiementCollapsed }"
    role="tablist"
    class="overflow-auto"
  >
    <div role="tabpanel">
      <form @submit="validationFormulaire">
        <div class="achat container">
          <h1>Commande de carte</h1>

          <!--          <h2>La création de cette carte personalisée sera facturée 5€00</h2>-->
          <h2>La création de cette carte personnalisée est gratuite</h2>

          <div class="encart_promo alert" role="alert">
            <p class="fw-bold mb-1">
              OFFRE DÉCOUVERTE* 100% GRATUITE : <br/>
              Pour toute création d'une nouvelle carte iSimouv', bénéficiez de 5 tickets OFFERTS chargés directement sur votre carte.
            </p>
            <p class="mb-0">
              <small
                >*Conditions : ne pas être déjà titulaire d'une carte
                iSimouv'</small
              >
            </p>
          </div>

          <div class="form_fabrication_carte pt-sm-5">
            <div class="carte_fabrication_carte card">
              <div class="card-body">
                <div>
                  <p style="text-align: center">
                    Indiquez les informations du titulaire du titre de transport
                  </p>

                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-user fa-2x"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        v-model="nom"
                        type="text"
                        class="form-control"
                        placeholder="Nom"
                        required
                      />
                    </div>
                  </div>
                  <div class="div_icon_input row">
                    <div class="col-sm-11 col-xs-10 offset-sm-1">
                      <input
                        v-model="prenom"
                        type="text"
                        class="form-control"
                        placeholder="Prénom"
                        required
                      />
                    </div>
                  </div>
                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fa-solid fa-location-dot fa-2x"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        v-model="adresse"
                        type="text"
                        class="form-control"
                        placeholder="Adresse"
                        required
                      />
                    </div>
                  </div>

                  <div class="div_icon_input row">
                    <div class="col-5 offset-sm-1">
                      <input
                        v-model="codePostal"
                        type="text"
                        class="form-control input-adresse"
                        placeholder="Code Postal"
                        required
                      />
                    </div>
                    <div class="col-7 col-sm-6">
                      <input
                        v-model="ville"
                        type="text"
                        class="form-control"
                        placeholder="Ville"
                        required
                      />
                    </div>
                  </div>

                  <div class="div_icon_input row">
                    <div class="col-sm-11 col-xs-10 offset-sm-1">
                      <input
                        v-model="complementAdresse"
                        type="text"
                        class="form-control"
                        placeholder="Complément d'adresse (Numéro appartement, Bâtiment, etc)"
                      />
                    </div>
                  </div>

                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fa-solid fa-flag fa-2x"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <select
                        id="pays"
                        class="form-control"
                        required
                        @change="pays = $event.target.value"
                      >
                        <option value="">Veuillez sélectionner un pays</option>
                        <option
                          v-for="item in paysList"
                          :key="item"
                          :value="item"
                        >
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-envelope"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        v-model="email"
                        type="email"
                        class="form-control"
                        id="exampleFormControlInput1"
                        placeholder="Adresse E-mail"
                        required
                      />
                    </div>
                  </div>
                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-mobile"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        v-model="mobile"
                        type="tel"
                        maxlength="12"
                        class="form-control"
                        id="telFormControlInput"
                        placeholder="Mobile avec indicatif (+33 pour la France)"
                        required
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-1 d-none d-sm-block"></div>
                    <label for="dateDeNaissance" class="col-sm-11 col-xs-10"
                      >Date de naissance</label
                    >
                  </div>
                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-calendar"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        type="date"
                        class="form-control"
                        v-model="dateNaissance"
                        id="dateDeNaissance"
                        @change="fetchCatalogue"
                        required
                      />
                    </div>
                  </div>

                  <p class="mt-3 mt-sm-5 fw-bold">
                    Sélectionnez le produit souhaité :
                  </p>
                  <div class="row">
                    <div class="col-sm-1 d-none d-sm-block"></div>
                    <label for="dateDeDebutDeTitre" class="col-sm-11 col-xs-10"
                      >Date de début titre</label
                    >
                  </div>
                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-calendar"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        type="date"
                        id="dateDeDebutDeTitre"
                        class="form-control"
                        v-model="dateDebutValidite"
                        :min="dateDebutValiditeMin"
                        @change="fetchCatalogue"
                        required
                      />
                    </div>
                  </div>

                  <div class="form-group pt-4">
                    <div class="div_icon_input row">
                      <div class="col-sm-1 text-center d-none d-sm-block">
                        <i class="fas fa-barcode"></i>
                      </div>
                      <div class="col-sm-11 col-xs-10">
                        <div>
                          <select
                            class="form-control"
                            required
                            @change="
                              verificationJustificatif(
                                JSON.parse($event.target.value),
                              )
                            "
                            :disabled="!dateNaissance || !dateDebutValidite"
                          >
                            <option value="">
                              Veuillez sélectionner un produit
                            </option>
                            <option
                              v-for="item in catalogue"
                              :key="item.id"
                              :value="JSON.stringify(item)"
                            >
                              {{ item.libelle }} ({{ toCurrency(item.tarif) }})
                            </option>
                          </select>
                          <p
                            v-if="!dateNaissance || !dateDebutValidite"
                            class="text-warning-emphasis"
                          >
                            Veuillez remplir les champs "Date de naissance" et
                            "Date de début titre" pour choisir un produit.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <p class="mt-3 mt-sm-5">
                    Personnalisez la carte avec la photo d'identité du futur
                    détenteur (Photo cadrée, droite et nette)
                  </p>
                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-file"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        ref="imageInput"
                        type="file"
                        @change="onChangeImageFile"
                        accept="image/jpeg"
                        class="form-control"
                        required
                      />
                      <p
                        :style="{
                          color:
                            imageValidationMessage.value === 'Format correct.'
                              ? 'green'
                              : 'red',
                        }"
                      >
                        {{ imageValidationMessage }}
                      </p>
                    </div>
                  </div>

                  <p class="mt-1">
                    Merci de fournir une pièce d’identité du détenteur
                  </p>
                  <div class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-file"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        ref="justificatifInput"
                        type="file"
                        @change="onChangeJustificatifDetenteurFile"
                        accept="application/pdf"
                        class="form-control"
                        multiple
                        required
                      />
                      <p
                        :style="{
                          color:
                            justificatifValidationMessage.value ===
                            'Format correct.'
                              ? 'green'
                              : 'red',
                        }"
                      >
                        {{ justificatifValidationMessage }}
                      </p>
                    </div>
                  </div>

                  <p
                    v-if="
                      visibiliteJustificatif &&
                      produit &&
                      produit.libelle.includes(
                        'Personne en situation de handicap ou PMR',
                      )
                    "
                    class="mt-1 mt-sm-2"
                  >
                    Le produit sélectionné nécessite de fournir une carte
                    mobilité inclusion (CMI)
                  </p>

                  <p
                    v-if="
                      visibiliteJustificatif &&
                      produit &&
                      produit.libelle.includes('CSS')
                    "
                    class="mt-1 mt-sm-2"
                  >
                    Le produit sélectionné nécessite de fournir un
                    complémentaire santé solidaire en cours de validité (CSS)
                  </p>

                  <p
                    v-if="
                      visibiliteJustificatif &&
                      produit &&
                      produit.libelle.includes('Demandeur d\'emploi')
                    "
                    class="mt-1 mt-sm-2"
                  >
                    Le produit sélectionné nécessite de fournir une attestation
                    France Travail en cours de validité
                  </p>

                  <div
                    v-if="
                      visibiliteJustificatif &&
                      produit &&
                      (produit.libelle.includes(
                        'Personne en situation de handicap ou PMR',
                      ) ||
                        produit.libelle.includes('CSS') ||
                        produit.libelle.includes('Demandeur d\'emploi'))
                    "
                    class="div_icon_input row"
                  >
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-file"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        ref="justificatifInput"
                        type="file"
                        @change="onChangeJustificatifFile($event)"
                        accept="application/pdf,image/png,image/jpeg"
                        class="form-control"
                        multiple
                        required
                      />
                      <p
                        :style="{
                          color:
                            justificatifMessage.value === 'Format correct.'
                              ? 'green'
                              : 'red',
                        }"
                      >
                        {{ justificatifMessage }}
                      </p>
                    </div>
                  </div>

                  <p>
                    <input v-model="isFuturDetenteur" type="checkbox" /> Cochez
                    si vous n'êtes pas le futur détenteur de la carte
                  </p>

                  <p v-if="isFuturDetenteur" class="mt-1 mt-sm-2">
                    Merci de fournir une pièce d'identité du signataire
                  </p>

                  <div v-if="isFuturDetenteur" class="div_icon_input row">
                    <div class="col-sm-1 text-center d-none d-sm-block">
                      <i class="fas fa-file"></i>
                    </div>
                    <div class="col-sm-11 col-xs-10">
                      <input
                        ref="justificatifInput"
                        type="file"
                        @change="onChangeJustificatifSignataireFile"
                        accept="application/pdf"
                        class="form-control"
                        multiple
                        required
                      />
                      <p
                        :style="{
                          color:
                            justificatifValidationMessage.value ===
                            'Format correct.'
                              ? 'green'
                              : 'red',
                        }"
                      >
                        {{ justificatifValidationMessage }}
                      </p>
                    </div>
                  </div>

                  <p class="mt-3 mt-sm-4 fw-bold">
                    Comment souhaitez-vous récupérer votre carte
                    d'abonnement ?
                  </p>
                  <div class="form-check mb-3">
                    <input
                      v-model="modeRetrait"
                      class="form-check-input"
                      type="radio"
                      name="modeRetrait"
                      id="modeRetraitAgence"
                      value="Retrait sur place"
                      required
                    />
                    <label class="form-check-label" for="modeRetraitAgence">
                      Retrait en agence iSimouv' - 1 rue de la Gare - 57400
                      Sarrebourg (disponible sous 24 heures - hors dimanches
                      et jours fériés)<br />
                      <small
                        >Horaires d'ouvertures : Lundi de 14h à 18h, Mardi à
                        Vendredi de 9h à 12h et de 14h à 18h, Samedi de 9h à
                        12h.</small
                      >
                    </label>
                  </div>
                  <div class="form-check mb-3">
                    <input
                      v-model="modeRetrait"
                      class="form-check-input"
                      type="radio"
                      name="modeRetrait"
                      id="modeRetraitPostal"
                      value="Envoi Postal"
                      required
                    />
                    <label class="form-check-label" for="modeRetraitPostal">
                      Envoi par voie postale (GRATUIT - délai estimé : 3 à 5
                      jours après traitement de votre dossier)
                    </label>
                  </div>

                  <p style="text-align: justify; font-weight: normal">
                    Les informations recueillies par iSimouv', à partir de ce
                    formulaire, font l’objet d’un traitement informatisé
                    nécessaire à la gestion des relations commerciales et au
                    suivi de votre demande. Ces données sont destinées à
                    iSimouv', qui est responsable de traitement, ainsi que, le
                    cas échéant à ses partenaires, sous-traitants ou
                    prestataires situés dans ou hors de l’Union Européenne et
                    aux filiales du Groupe Keolis. Vos données sont conservées
                    pour la durée nécessaire au traitement de votre demande, à
                    la gestion administrative et comptable des services
                    souscrits et la promotion des services.<br />
                    Pour plus d’informations, nous vous invitons à consulter
                    notre
                    <a
                      class="lien"
                      target="_blank"
                      href="Politique-de-confidentialite-iSiMouv.pdf"
                      >Politique de confidentialité</a
                    >.<br />
                    Conformément à la règlementation applicable, vous disposez
                    d’un droit d’accès, de rectification et/ou de suppression de
                    vos données personnelles. Vous pouvez également vous opposer
                    à leur traitement à des fins commerciales. Vous pouvez
                    exercer ces droits, ou adresser toute autre question aux
                    coordonnées postales ou électroniques disponibles
                    précédemment indiquées.<br />
                  </p>

                  <p>
                    <input
                      v-model="isRenseignementsChecked"
                      type="checkbox"
                      required
                    />
                    Je certifie l'exactitude des renseignements fournis dans ce
                    formulaire.
                  </p>

                  <p>
                    <input v-model="isRGPDChecked" type="checkbox" required />
                    J’ai lu et compris la déclaration de confidentialité quant à
                    la protection, le stockage et l’utilisation de mes données
                    personnelles et donne mon consentement pour le traitement de
                    toutes les données fournies dans mon dossier électronique
                    dans le cadre de ma demande, y compris l’utilisation par des
                    organisations externes.
                  </p>

                  <p>
                    <input v-model="needFacture" type="checkbox" /> Je souhaite
                    avoir une facture.
                  </p>

                  <div class="text-center">
                    <button type="submit" class="btn btn-vert">
                      <i class="fas fa-arrow-right"></i>
                      Valider
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div id="modal_erreur" title="Erreur...">
      <div class="carte">
        <div>
          <p class="description error">{{ erreurMessage }}</p>
        </div>
      </div>
    </div>
  </div>

  <div
    :class="{ collapse: isPaiementCollapsed, show: !isPaiementCollapsed }"
    role="tabpanel"
  >
    <div class="paiement container">
      <h1>Finalisation de votre achat - Paiement</h1>
      <h2>Récapitulatif de votre achat</h2>

      <div class="carte_recap card">
        <div class="card-body">
          <h5 class="card-text">Titulaire : {{ prenom }} {{ nom }}</h5>
          <h5 class="card-text">Produit : Carte</h5>
          <h5 class="card-text">
            Montant : {{ toCurrency(montantFabricationCarte) }}
          </h5>
        </div>
      </div>
      <div
        id="PaylineWidget"
        :data-token="paymentToken"
        data-template="column"
        data-auto-init="true"
        data-embeddedredirectionallowed="false"
      />
    </div>
  </div>

  <div
    class="modal fade"
    id="modal_erreur"
    tabindex="-1"
    aria-labelledby="modalErreurLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalErreurLabel">Erreur...</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="carte">
            <div>
              <p class="description error">{{ erreurMessage }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            data-bs-dismiss="modal"
            @click="recommencerAchat"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal_erreur"
      tabindex="-1"
      aria-labelledby="modalErreurLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalErreurLabel">Erreur...</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="carte">
              <div>
                <p class="description error">{{ erreurMessage }}</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="recommencerAchat"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/assets/main';

.md-steppers .md-steppers-navigation {
  display: none;
}

.form_fabrication_carte {
  .carte_fabrication_carte {
    border: none !important;

    .bouton_valid {
      display: block;
      margin: auto;
      @include boutons;
    }

    .bouton_valid:hover {
      @include boutons_hover;
    }

    .div_icon_input {
      display: flex;
      margin-bottom: 1rem;
      @include icon_form;

      &:focus-within {
        i {
          color: var(--color-bleu-logo);
        }
      }
    }
  }
}

.encart_promo {
  color: var(--color-bleu-fonce);
  background-color: rgba(95, 176, 208, 0.15);
  border-color: var(--color-bleu-logo);
  text-align: center;
}

.error {
  color: red !important;
}
</style>
